import { useCallback, useEffect, useState } from "react";
import { CalendarClock, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("nl-NL", { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
const eur = (v) => new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(v || 0);

export default function WeeklyReportRow() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { setData((await api.get("/admin/help/weekly-report")).data); } catch { setData(null); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const send = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/help/weekly-report/send", null, { params: { force: true } });
      toast.success(`Weekrapport ${r.week} verstuurd naar ${r.to}: ${r.summary.questions} vragen, ${eur(r.summary.cost_eur)}.`);
      await load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="border-2 border-foreground bg-background p-3 flex flex-wrap items-center justify-between gap-3" data-testid="weekly-report-row">
      <div className="text-xs">
        <div className="font-display font-black uppercase tracking-tight text-sm inline-flex items-center gap-2"><CalendarClock className="w-4 h-4" /> Weekrapport</div>
        <div className="text-muted-foreground mt-0.5">
          Elke maandag 08:00 NL-tijd naar <span className="font-mono-num">{data?.notify_to || "—"}</span> · volgende: <span className="font-mono-num" data-testid="weekly-report-next">{fmt(data?.next_run)}</span>
          {data?.last ? <> · laatste: <span className="font-mono-num" data-testid="weekly-report-last">{data.last.week} op {fmt(data.last.sent_at)}</span></> : <> · <span data-testid="weekly-report-last">nog niet verstuurd</span></>}
        </div>
      </div>
      <button onClick={send} disabled={busy} data-testid="weekly-report-send"
        className="btn-brutal bg-background text-foreground px-3 py-1.5 font-display uppercase font-bold text-xs inline-flex items-center gap-1.5 disabled:opacity-50">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} Nu versturen
      </button>
    </div>
  );
}
